/* eslint no-use-before-define: 0 */
/* eslint prefer-rest-params: 0 */

import $ from "jquery";

// https://developers.google.com/maps/documentation/javascript/error-messages#deverrorcode
const gmErrorList = [
    "InvalidKeyOrUnauthorizedURLMapError",
    "NotLoadingAPIFromGoogleMapError",
    "TOSViolationMapError",
    "UnauthorizedURLForClientIdMapError",
    "ApiNotActivatedMapError",
    "DeletedApiProjectMapError",
    "ExpiredKeyMapError",
    "InvalidClientIdMapError",
    "InvalidKeyMapError",
    "MissingKeyMapError",
    "ProjectDeniedMapError",
    "RefererDeniedMapError",
    "RefererNotAllowedMapError",
    "OverQuotaMapError",
    "ApiProjectMapError",
    "ClientIdLooksLikeCryptoKey",
    "ClientIdLooksLikeKey",
    "InvalidChannel",
    "InvalidClientId",
    "InvalidKey",
    "InvalidVersion",
    "KeyLooksLikeClientId",
    "KeyLooksLikeCryptoKey",
    "KeyLooksLikeProjectNumber",
    "NoApiKeys",
    "RetiredVersion",
    "SensorNotRequired",
    "SignatureNotRequired",
    "SignedInNotSupported",
    "UrlAuthenticationCommonError",
];

/**
 * This class contains deprecated console intercept errors code.
 */
export default class ErrorService {
    /**
     * @param {Object} jqNode - map component`s jqNode
     */
    constructor(jqNode) {
        this.jqNode = jqNode;
    }

    static showCommonError(errorText) {
        $(".map-error-placeholder-js").append(this.createErrorHTML(errorText));
    }

    /**
     * @param {string} errorText
     * @private
     */
    static createErrorHTML(errorText) {
        return `
            <div class="alert alert-danger" role="alert">
              ${errorText}
            </div>
        `;
    }

    showError(errorText) {
        this.jqNode.hide();
        this.jqNode
            .parent()
            .parent()
            .find(".map-error-placeholder-js")
            .append(ErrorService.createErrorHTML(errorText));
    }

    // eslint-disable-next-line class-methods-use-this
    initDisplayingGoogleMapsError() {
        interceptConsoleError();

        function interceptConsoleError() {
            const method = "error";
            // eslint-disable-next-line no-console
            const original = console[method];
            const methodContext = this;
            // eslint-disable-next-line no-console
            console[method] = function initErrorHandling() {
                if (arguments[0]) {
                    gmErrorList.forEach((errorName) => {
                        try {
                            if (arguments[0].indexOf(errorName) !== -1 && methodContext) {
                                methodContext.handleError(`Google maps error: ${errorName}`);
                            }
                        } catch (e) {
                            console.log("error ocurred in error service");
                            console.dir(e);
                        }
                    });
                }

                if (original.apply) {
                    // Do this for normal browsers
                    original.apply(console, arguments);
                } else {
                    // Do this for IE
                    const message = Array.prototype.slice.apply(arguments).join(" ");
                    original(message);
                }
            };
        }
    }
}
